export const generateUrl =
  ({
    stateSecondFactor,
    overrideCode,
    productType: product,
    locale,
    giftOrder: gift,
    initialPageLoadParams,
    retailerMoniker,
  }) =>
  ({ orderNumber, secondFactorInput }) => {
    const searchParams = new URLSearchParams('');

    const removeParams = new Set(['code', 'userType', 'usertype', 'exception']);

    const filteredParams = Object.fromEntries(
      Object.entries(initialPageLoadParams || {}).filter(([key]) => !removeParams.has(key)),
    );

    Object.entries({
      ...filteredParams,
      ...(secondFactorInput || stateSecondFactor || {}),
      gift,
      locale,
      product,
      ...(overrideCode && { return_override_code: overrideCode }),
      timestamp: Date.now().toString(),
      version: 3,
    }).forEach(([key, value]) => {
      searchParams.append(key, value);
    });

    return `/returns/${retailerMoniker}/order/${orderNumber}?${searchParams.toString()}`;
  };

export const generateOptions = ({ browserFingerprint }) => ({
  method: 'GET',
  headers: { 'narvar-tfid': browserFingerprint, 'narvar-multi-order': 'true' },
});

export const hasMultiOrder = ({ returnItems }) => {
  const orderNumbers = returnItems.map((item) => item.order_number);
  const uniqueOrderNumbers = new Set(orderNumbers);
  return uniqueOrderNumbers.size > 1;
};
